import type { FormTourConfig } from './formTour';

const START_SEQUENCE_START_PATH = '/sequences';
const SEQUENCES_PATH_PREFIX = '/sequences';

export const startSequenceTour = {
  taskId: 'start_sequence',
  storageKey: 'onboarding-start-sequence-tour-step',
  startPath: START_SEQUENCE_START_PATH,
  activePathPrefix: SEQUENCES_PATH_PREFIX,
  navStepCount: 1,
  overlineLabel: 'Start Sequence Tour',
  steps: [
    {
      title: 'Open Sequences',
      description: 'Click Sequences in the sidebar to view your outreach sequences.',
      targetTestIds: ['@sidebar-sequences'],
    },
    {
      title: 'Show draft sequences',
      description:
        'Sequences stay in draft until you start them. Click the Draft filter to find the sequence you created.',
      targetTestIds: ['@sequences-filter-draft'],
      disableBack: true,
    },
    {
      title: 'Select Sequence',
      description: 'In the draft list, click the sequence name to open it.',
      targetTestIds: ['@sequence-open-link'],
      disableBack: true,
    },
    {
      title: 'Open Steps',
      description: 'Open the Steps tab. The Draft / Active switch is at the top of this tab.',
      targetTestIds: ['@sequence-tab-steps'],
      disableBack: true,
    },
    {
      title: 'Set status to Active',
      description:
        'Toggle the switch from Draft to Active. Starting a sequence begins sending emails to enrolled candidates.',
      targetTestIds: ['@sequence-status-switch'],
      closeTargetTestIdsOnBack: ['@sequence-activate-confirm-modal'],
    },
    {
      title: 'Confirm and start',
      description:
        'Review the sequence details, then click Confirm and Start Sequence. The guide finishes when the sequence is active.',
      targetTestIds: ['@sequence-activate-confirm'],
      highlightTargetTestIds: ['@sequence-activate-confirm'],
      contextTargetTestIds: ['@sequence-activate-confirm-modal'],
      panelPlacement: 'above',
      closeTargetTestIdsOnBack: ['@sequence-activate-confirm-modal'],
    },
  ],
  stepActions: {
    0: {
      type: 'wait-for-target',
      advanceTo: 1,
      waitForTargetTestIds: ['@sequences-filter-draft'],
    },
    1: {
      type: 'wait-for-target',
      advanceTo: 2,
      waitForTargetTestIds: ['@sequences-filter-draft-active'],
    },
    2: {
      type: 'wait-for-target',
      advanceTo: 3,
      waitForTargetTestIds: ['@sequence-name-edit'],
    },
    3: {
      type: 'wait-for-target',
      advanceTo: 4,
      waitForTargetTestIds: ['@sequence-status-switch'],
    },
    4: {
      type: 'wait-for-target',
      advanceTo: 5,
      waitForTargetTestIds: ['@sequence-activate-confirm-modal'],
    },
    5: {
      type: 'complete-when-target',
      waitForTargetTestIds: ['@sequence-status-active'],
    },
  },
} as const satisfies FormTourConfig;
